/**
 * A reusable debounce function for TypeScript.
 * @param func The function to be debounced.
 * @param delay The delay in milliseconds.
 * @returns A debounced version of the original function.
 */
export function debounce<T extends (...args: any[]) => void>(
    func: T,
    delay: number
): (...args: Parameters<T>) => void {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    return function (this: any, ...args: Parameters<T>) {
        // Clear the previous timer if the function is called again before the delay
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        // Set a new timer
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}
